// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ow8iMJES2zXwq7ZrVR__ {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}

.mh_oAzlNwzXZ0j6JMook {
  color: #fff;
}

.jCW24H6C_e_NLOkDrfxq {
  width: 1.5rem;
  height: 1.5rem;
}

.hqbpiQb4viPEtrzoM3TH {
  display: flex;
  align-items: center;
}

.DzUQBEI7VoNvnijt2mjI {
  display: flex;
}

.goBkJQRZoM_smaP8GIVA {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.75rem;
}

.D8ojmjrRot5yptPV4jDY {
  font-size: 1rem;
  padding: 0.5rem;
}

.HZe1FkUz_16RKTMoLGmO {
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderMenuContentFooterItem/HeaderMenuContentFooterItem.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAW;EACX,cAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAW;EACX,cAAY;EACZ,qBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAY;AACd;;AAEA;EACE,mBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".menuItemContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n}\n\n.itemTitle {\n  color: #fff;\n}\n\n.arrowIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.collapsePanel {\n  display: flex;\n  align-items: center;\n}\n\n.itemContent {\n  display: flex;\n}\n\n.itemIcon {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n}\n\n.accordionItem {\n  font-size: 16px;\n  padding: 8px;\n}\n\n.accordionItems {\n  padding-top: 8px;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuItemContainer": `ow8iMJES2zXwq7ZrVR__`,
	"itemTitle": `mh_oAzlNwzXZ0j6JMook`,
	"arrowIcon": `jCW24H6C_e_NLOkDrfxq`,
	"collapsePanel": `hqbpiQb4viPEtrzoM3TH`,
	"itemContent": `DzUQBEI7VoNvnijt2mjI`,
	"itemIcon": `goBkJQRZoM_smaP8GIVA`,
	"accordionItem": `D8ojmjrRot5yptPV4jDY`,
	"accordionItems": `HZe1FkUz_16RKTMoLGmO`
};
export default ___CSS_LOADER_EXPORT___;
